import React from "react";
import { mobileMenuLinks } from "../lib/navLinks";
import { Link, NavLink } from "react-router";

export default function MobileMenu() {
  return (
    <div className="fixed inset-0 z-30 h-screen w-screen bg-slate-300 p-6 sm:px-8 md:px-10 lg:hidden">
      <div className="mb-8 mt-28 flex justify-center gap-4">
        <Link
          to={"/contact"}
          className="rounded-3xl bg-primaryColor px-3 py-2 text-sm font-bold text-secondaryColor shadow-md transition-all focus:bg-primaryHover focus:shadow-none active:bg-primaryHover active:shadow-none"
        >
          Contact Us
        </Link>
      </div>
      <ul className="flex flex-col gap-4 sm:gap-6 md:gap-8">
        {mobileMenuLinks.map((link, index) => {
          return (
            <li key={index}>
              <NavLink
                to={link.url}
                className={({ isActive }) =>
                  `${isActive && "text-secondaryColor"} text-lg text-primaryColor sm:text-xl md:text-2xl`
                }
              >
                {link.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
